export const POLARIS_CONFIG = {
  clientId: "rv_comcast_landing_page",
  baseUrl: {
    production: "https://polaris.xfinity.com",
    staging: "https://polaris.staging.xfinity.com",
  },
} as const;
